// extracted by mini-css-extract-plugin
module.exports = {"badge-wrap":"Badge_badge-wrap__cDTMB","badge-text":"Badge_badge-text__jx0NS"};